import { createCanvas } from '@meitu/saas-editor-core/es/utils/file-kit';
import { uploadBase64ToObs } from '@meitu/saas-editor-core/es/utils/upload-kit';
import { ISize } from '@meitu/saas-editor-core/es/version-types';
import { DownloadImgType } from '@meitu/saas-editor-ui/es/constants';
import { createWaterMark } from './water-mark';

export const getPreviewImage = async (
    resultCanvas: HTMLCanvasElement,
    imgType: DownloadImgType,
    preview: string,
    size?: { width: number; height: number },
    // 透明度
    opacity?: number,
) => {
    try {
        // 缩略图按 w=640
        const sw = resultCanvas!.width;
        const sh = resultCanvas!.height;
        let dw = Math.min(sw, 640),
            dh = sh;
        if (dw !== sw || size) {
            const ratio = sw / sh;
            // 封面宽度
            dh = dw / ratio;
            if (size) {
                const { width, height } = size;
                dw = width;
                dh = height;
            }
            const { canvas, ctx } = createCanvas(dw, dh);
            ctx.drawImage(resultCanvas!, 0, 0, sw, sh, 0, 0, dw, dh);
            resultCanvas = canvas;
        }

        const mineType = imgType === 'png' ? 'image/png' : 'image/jpeg';
        const base64 = resultCanvas.toDataURL(mineType, opacity ?? 0.8);
        // console.time('缩略图上传，作图记录时间： =>');
        const { url } = await uploadBase64ToObs(base64);
        // throw '模拟图片生成失败';
        return {
            url,
            width: dw,
            height: dh,
        };
    } catch {
        return {
            url: preview,
            width: resultCanvas.width,
            height: resultCanvas.height,
        };
    }
};
